import { FleekError } from './FleekError';

type GitProviderNotFoundErrorOptions = {
  providerId?: string;
};

export class GitProviderNotFoundError extends FleekError<GitProviderNotFoundErrorOptions> {
  public name = 'GitProviderNotFoundError';

  toString = () => {
    return `No Git Provider found with id: ${this.data.providerId}`;
  };
}
